<div class="customer-detail">
  <div *ngIf="isLoading">
    <app-skeleton
      *ngFor="let i of [].constructor(3)"
      width="100%"
      height="250px"
      margin="0 0 30px"
    ></app-skeleton>
  </div>
  <div *ngIf="customerDetails">
    <div class="customer-detail__row flex-wrap">
      <section>
        <h3>Customer Information</h3>
        <table>
          <tr>
            <th>Full Name</th>
            <td>{{ customerDetails?.customer?.fullName }}</td>
          </tr>
          <tr>
            <th>Email</th>
            <td>{{ customerDetails?.customer?.email }}</td>
          </tr>
          <tr>
            <th>Phone Number</th>
            <td>{{ customerDetails?.customer?.phone }}</td>
          </tr>
          <tr>
            <th>Address</th>
            <td>
              {{ customerDetails?.customer?.address?.address1 }},
              {{ customerDetails?.customer?.address?.city }},{{
                customerDetails?.customer?.address?.state
              }}, {{ customerDetails?.customer?.address?.zipcode }},
              {{ customerDetails?.customer?.address?.country }}
            </td>
          </tr>
          <tr>
            <th>Created Date</th>
            <td>{{ customerDetails?.customer?.createdAt }}</td>
          </tr>
        </table>
      </section>

      <section>
        <h3>Vehicle Information</h3>
        <table>
          <tr>
            <th>Make</th>
            <td>
              {{ customerDetails?.vehicle?.make }}
            </td>
          </tr>
          <tr>
            <th>model</th>
            <td>
              {{ customerDetails?.vehicle?.model }}
            </td>
          </tr>
          <tr>
            <th>Year</th>
            <td>
              {{ customerDetails?.vehicle?.year }}
            </td>
          </tr>
          <tr>
            <th>Vin</th>
            <td>
              {{ customerDetails?.vehicle?.vin }}
            </td>
          </tr>
          <tr>
            <th>Purchase Mileage</th>
            <td>
              {{ customerDetails?.vehicle?.purchaseMileage }}
            </td>
          </tr>
        </table>
      </section>
      <section>
        <h3>VSC Contract Details</h3>
        <table>
          <tr>
            <th>Plan Type</th>
            <td>{{ customerDetails?.vscContract?.planType }}</td>
          </tr>
          <tr>
            <th>Start Date</th>
            <td>{{ customerDetails?.vscContract?.startDate }}</td>
          </tr>
          <tr>
            <th>End Date</th>
            <td>{{ customerDetails?.vscContract?.endDate }}</td>
          </tr>
          <tr>
            <th>Term Months</th>
            <td>{{ customerDetails?.vscContract?.termMonths }}</td>
          </tr>
          <tr>
            <th>Term Miles</th>
            <td>{{ customerDetails?.vscContract?.termMiles }}</td>
          </tr>
          <tr>
            <th>Retail Rate</th>
            <td>{{ customerDetails?.vscContract?.retailRate }}</td>
          </tr>
          <tr>
            <th>Dealer Cost</th>
            <td>{{ customerDetails?.vscContract?.dealerCost }}</td>
          </tr>
          <tr>
            <th>Sales Tax</th>
            <td>{{ customerDetails?.vscContract?.salesTax }}</td>
          </tr>
          <tr>
            <th>Description</th>
            <td>{{ customerDetails?.vscContract?.description }}</td>
          </tr>
        </table>
      </section>
      <section>
        <h3>Policy Details</h3>
        <table>
          <tr>
            <th>Plan Type</th>
            <td>{{ customerDetails?.vscContract?.planType }}</td>
          </tr>
          <tr>
            <th>Start Date</th>
            <td>{{ customerDetails?.vscContract?.startDate }}</td>
          </tr>
          <tr>
            <th>End Date</th>
            <td>{{ customerDetails?.vscContract?.endDate }}</td>
          </tr>
          <tr>
            <th>Deductible</th>
            <td>{{ customerDetails?.vscContract?.termMonths }}</td>
          </tr>
          <tr>
            <th>Contract PDF</th>
            <td>
              <a
                [ngClass]="
                  customerDetails?.vscContract?.contractPdfUrl
                    ? ''
                    : 'is-disabled'
                "
                class="is-button"
                [href]="customerDetails?.vscContract?.contractPdfUrl"
                target="_blank"
                >Download</a
              >
            </td>
          </tr>
          <tr>
            <th>RIC PDF</th>
            <td>
              <a
                [ngClass]="
                  customerDetails?.vscContract?.ricPdfUrl ? '' : 'is-disabled'
                "
                class="is-button"
                [href]="customerDetails?.vscContract?.ricPdfUrl"
                target="_blank"
                >Download</a
              >
            </td>
          </tr>
          <tr>
            <th>AUTH PDF</th>
            <td>
              <a
                [ngClass]="
                  customerDetails?.vscContract?.authPdfUrl ? '' : 'is-disabled'
                "
                class="is-button"
                [href]="customerDetails?.vscContract?.authPdfUrl"
                target="_blank"
                >Download</a
              >
            </td>
          </tr>
          <tr>
            <th>Sales Tax</th>
            <td>{{ customerDetails?.vscContract?.salesTax }}</td>
          </tr>
          <tr>
            <th>Description</th>
            <td>{{ customerDetails?.vscContract?.description }}</td>
          </tr>
        </table>
      </section>
    </div>
    <section>
      <h3>Claims</h3>
      <div class="customer-detail__scroll">
        <table class="is-claim">
          <tr>
            <th>Claim Type</th>
            <th>Breakdown Date</th>
            <th>Issue Description</th>
            <th>Claim Submit Date</th>
          </tr>
          <ng-container
            *ngIf="
              customerDetails?.claims &&
                (customerDetails?.claims?.length ?? 0) > 0;
              else noDataFound
            "
          >
            <tr *ngFor="let claim of customerDetails?.claims">
              <td>{{ claim.claimType }}</td>
              <td>{{ claim.breakdownDate ?? "" | date : "MMM d, y" }}</td>
              <td>{{ claim.issueDescription }}</td>
              <td>{{ claim.submittedAt ?? "" | date : "MMM d, y" }}</td>
            </tr></ng-container
          >
        </table>
      </div>
    </section>
  </div>
</div>
<ng-template #noDataFound>
  <tr>
    <td colspan="4">
      <div class="table-block__nodata">No data found</div>
    </td>
  </tr>
</ng-template>
